import NotFoundPage from "./404NotFound";

export default NotFoundPage;
